'use strict';

var RelatedStories = function RealtedStories() {
  $('.view-related-stories article').matchHeight();
};

export default RelatedStories;
